// Auto-generated by scripts/generate-registry.mjs from packages/modules/text_ribbon_3line/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const text_ribbon_3line: ModuleSchema = {
  "id": "text_ribbon_3line",
  "uniqueId": "B3D_TR3L1",
  "createdAt": "2026-10-15T00:00:00Z",
  "updatedAt": "2026-10-15T05:04:02.584Z",
  "label": "Three-Line Text Ribbon",
  "description": "Custom three-line raised text, split into independently colored rows.",
  "category": "accessories",
  "tags": [
    "text",
    "ribbon",
    "three-line",
    "custom"
  ],
  "sliders": [
    {
      "key": "fontSize",
      "label": "Letter Height",
      "min": 3,
      "max": 20,
      "default": 7.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    },
    {
      "key": "baseThickness",
      "label": "Custom Base Thickness",
      "min": 0.1,
      "max": 3,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        2,
        4
      ]
    },
    {
      "key": "textHeight",
      "label": "Raised Text Thickness",
      "min": 0.1,
      "max": 1,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1,
        3,
        5
      ]
    },
    {
      "key": "baseOffset",
      "label": "Text Border Offset",
      "min": 0.2,
      "max": 5,
      "default": 1.8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        2,
        4
      ]
    },
    {
      "key": "rowGap",
      "label": "Row Gap",
      "min": 0,
      "max": 20,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0,
        1,
        2,
        3,
        4,
        5
      ]
    }
  ],
  "selects": [],
  "textParams": [
    {
      "key": "text",
      "label": "Three Text Rows (one row per line)",
      "default": "TRI ÂN QUÁ KHỨ\nKIẾN TẠO TƯƠNG LAI\nVỮNG BƯỚC VƯƠN XA",
      "kind": "textarea",
      "enabled": true,
      "visible": true
    },
    {
      "key": "fontStyle",
      "label": "Font Family",
      "default": "roboto",
      "kind": "font",
      "enabled": true,
      "visible": true
    }
  ],
  "colorConfigs": [
    {
      "key": "line1_base",
      "label": "Line 1 Base Color",
      "default": "#1D4ED8",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "line1_text",
      "label": "Line 1 Text Color",
      "default": "#FFFFFF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "line2_base",
      "label": "Line 2 Base Color",
      "default": "#DC2626",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "line2_text",
      "label": "Line 2 Text Color",
      "default": "#FFFFFF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "line3_base",
      "label": "Line 3 Base Color",
      "default": "#0284C7",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "line3_text",
      "label": "Line 3 Text Color",
      "default": "#FFFFFF",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        5
      ]
    }
  ],
  "objects": [
    {
      "id": "line_1",
      "label": "Line 1",
      "name": "Line 1",
      "color": "#1D4ED8",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": []
    },
    {
      "id": "line_2",
      "label": "Line 2",
      "name": "Line 2",
      "color": "#DC2626",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": []
    },
    {
      "id": "line_3",
      "label": "Line 3",
      "name": "Line 3",
      "color": "#0284C7",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": []
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Three-Line Text"
    }
  ]
};
